var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { isValidTicketField } from "../../Utils";
var EmailForm = function (props) {
    var executeAiAction = props.executeAiAction;
    var fieldData = {
        name: "email",
        label: "Your email",
        type: "email",
        required: true,
        value: "",
        placeholder: "user@gmail.com",
        error: "",
        is_valid: true,
        display: true,
    };
    var _a = useState([fieldData]), formFields = _a[0], setFormFields = _a[1];
    var _b = useState(formFields[0]), field = _b[0], setField = _b[1];
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var isvalidForm = function () {
        var isValid = true;
        var results = formFields.map(function (field) {
            field = isValidTicketField(field);
            if (isValid)
                isValid = field.is_valid;
            return field;
        });
        setFormFields(results);
        return isValid;
    };
    var submitForm = function () {
        // Clear error
        if (isvalidForm() && !saving) {
            setSaving(true);
            executeAiAction("", field.value, "My email is " + field.value);
            setSaving(false);
        }
    };
    var handleFieldValueChange = function (value, field) {
        var results = formFields.map(function (eachField) {
            if (eachField.name == field.name)
                eachField.value = value;
            if (eachField.error)
                eachField = isValidTicketField(eachField);
            return eachField;
        });
        setFormFields(results);
    };
    return (_jsx("div", __assign({ className: "chat__ticket-form-main chat_agent_data chat_flows-login" }, { children: _jsxs("div", __assign({ className: "chat__ticket-form1 chat_flows-login-form chat__messages-form chatuserformdata" }, { children: [_jsx("div", __assign({ className: "text-left", style: { marginBottom: "5px" } }, { children: _jsx("pre", { children: _jsx("p", __assign({ className: "mb-2" }, { children: "Enter Email" })) }) })), _jsxs("div", __assign({ className: "chat__messages-form-group" }, { children: [_jsx("input", { type: field.type, placeholder: field.placeholder, required: field.required, name: field.name, className: "chat_form-control", value: field.value, onChange: function (e) { return handleFieldValueChange(e.target.value, field); } }), field.error ? (_jsx("div", __assign({ className: "error-content" }, { children: field.error }))) : (_jsx(_Fragment, {}))] })), _jsx("span", __assign({ style: {
                        display: "flex",
                        alignItems: "center",
                    } }, { children: _jsx("button", __assign({ className: "chat__messages-btn", onClick: submitForm }, { children: saving ? "Sending ..." : "Submit" })) }))] })) })));
};
export default EmailForm;
